<template>
    <div v-if="orfValue || doNotHide">
        <slot
            :required="orfValue === 2"
            :hidden="orfValue === 0" />
    </div>
</template>

<script>
import registrationOnlineRegistrationFieldsMixin from "@/mixins/registration/registrationOnlineRegistrationFieldsMixin";

export default {
    name: "OrfEval",
    mixins: [registrationOnlineRegistrationFieldsMixin],
    props: {
        doNotHide: {
            type: Boolean,
            default: false
        },
        orfName: {
            type: String,
            description: "Name of the associated Onlineanmeldefeld"
        },
        orfType: {
            type: String,
            description: "Type of the associated Onlineanmeldefeld"
        }
    },
    computed: {
        orfValue() {
            return this.getOrfValue(this.orfName, this.orfType)
        }
    }
}
</script>

<style scoped>

</style>